import { rest } from 'msw'

import { getResponseObject } from '@webapp/tests/getResponseObject'
import { type AuditLogRecordApiModel } from '../api-models/AuditLogRecordApiModel'
import { AuditLogRecordApiModelStub } from '../api-models/stubs/AuditLogRecordApiModel.stub'

export const mockGetAuditLog = (
  contentTypeId: number,
  objectId: string,
  data: AuditLogRecordApiModel[] = AuditLogRecordApiModelStub.buildList(1),
  pagination = {},
  metadata = {}
) => {
  return rest.get(
    `/api/v3/audit/${contentTypeId}/${objectId}/`,
    (_, res, ctx) => {
      return res.once(
        ctx.status(200),
        ctx.json(getResponseObject(data, pagination, metadata))
      )
    }
  )
}
